// Product name shown in the UI, page title and support mails. Change here to rename the product (e.g. "Sweap Docs").
export const PRODUCT_NAME = "EventDocs";
export const PRODUCT_FULL_NAME = "Sweap EventDocs";
